let isESBOnline : boolean = true;

export class ESBOnlineService {
  public static setESBIsOnline(isOnline : boolean) {
    isESBOnline = isOnline;
  }

  public static getESBIsOnline() {
      return  isESBOnline;
  }
}